/* tslint:disable */
/* eslint-disable */
/**
 * Control Online API
 * Control Online API
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
/**
 *
 * @export
 * @interface MonthPlanChangeOverflowFund
 */
export interface MonthPlanChangeOverflowFund {
  /**
   *
   * @type {string}
   * @memberof MonthPlanChangeOverflowFund
   */
  fundId: string | null;
}

export function MonthPlanChangeOverflowFundFromJSON(json: any): MonthPlanChangeOverflowFund {
  return MonthPlanChangeOverflowFundFromJSONTyped(json, false);
}

export function MonthPlanChangeOverflowFundFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): MonthPlanChangeOverflowFund {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    fundId: json["fundId"],
  };
}

export function MonthPlanChangeOverflowFundToJSON(value?: MonthPlanChangeOverflowFund | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    fundId: value.fundId,
  };
}
